import { API_URL_VERSION } from "../constants/environment";
import api from "./api";
import { toSearchFilter } from "../utils";

export const ENDPOINT_PROCESSES = API_URL_VERSION + 'processos'
export const ENDPOINT_PROCESSES_LIST = ENDPOINT_PROCESSES + '/listar'
export const ENDPOINT_PROCESSES_GET_DETAIL_UPDATE_DELETE = API_URL_VERSION + 'processos/'
export const ENDPOINT_DOCUMENT_TYPES = "/tipo-documento-sgmt";
export const ENDPOINT_PROCESSES_EXPORT = ENDPOINT_PROCESSES + '/exportar'
export const ENDPOINT_PROCCESSES_ATTACH_DOCUMENT = ENDPOINT_PROCESSES + '/anexar-documentos-processos'
export const ENDPOINT_PROCESSES_FORWARD = ENDPOINT_PROCESSES + '/encaminhar'
export const ENDPOINT_PROCESSES_ARCHIVE = ENDPOINT_PROCESSES + '/arquivar'
export const ENDPOINT_PROCESSES_REASSIGN = ENDPOINT_PROCESSES + '/reatribuir'
export const ENDPOINT_PROCESSES_REOPEN = ENDPOINT_PROCESSES + '/reabrir'
export const ENDPOINT_PROCESSES_JUDGE = ENDPOINT_PROCESSES + '/julgar'
export const ENDPOINT_PROCESSES_CONFIRM_RECEIPT = ENDPOINT_PROCESSES + '/confirmar-recebimento'
export const ENDPOINT_PROCESSES_PRINT_CA_DETAILS = ENDPOINT_PROCESSES + '/imprimir-capa'
export const ENDPOINT_PROCESSES_ATTACHMENT_DELETE = ENDPOINT_PROCESSES + '/remover-anexo'
export const ENDPOINT_PROCESSES_SEND_MAIL = ENDPOINT_PROCESSES + '/enviar-email'
export const ENDPOINT_PROCESSES_FINAL_DECISION = ENDPOINT_PROCESSES + '/preencher-decisao-final';
export const ENDPOINT_PROCESSES_ATTACHMENT_VIEW = ENDPOINT_PROCESSES + '/anexo'
export const ENDPOINT_PROCESSES_REEXAMINE  = ENDPOINT_PROCESSES + '/reexaminar'
export const ENDPOINT_PROCESS_TYPES = ENDPOINT_PROCESSES + '/tipos'
export const ENDPOINT_PROCESS_PRINT_NP_TRIAL = ENDPOINT_PROCESSES + '/imprimir-nps-relato-julgamento'
export const ENDPOINT_PROCESSES_USER_LIST = ENDPOINT_PROCESSES + '/usuarios'
export const ENDPOINT_PROCESSES_DEPARTMENT_LIST = ENDPOINT_PROCESSES + '/departamentos'
/** GET …/processos/infracao/{id_infracao} — lista enxuta: id, numero (ou nome) */
export const ENDPOINT_PROCESSES_BY_INFRACTION = ENDPOINT_PROCESSES + '/infracao/'

export const PROCESS_TYPES = {
    IC: 'ic',
    NA: 'na',
    NP: 'np',
    RE: 're',
    CE: 'ce',
    AD: 'ad',
};

export const JUDGE_OPTIONS = {
    DEFERIDA: 'defer',
    INDEFERIDA: 'reject',
    DILIGENCIA: 'diligence'
}

export const indeferPattern = /\bindef/;
export const diligenciaPattern = /\bdilig[êe]ncia/;
export const deferPattern = /\bdefer/;

export const JUDGMENT_OPTIONS = {
  INDEFERIDA: "INDEFERIDA",
  DILIGENCIA: "DILIGENCIA",
  DEFERIDA: "DEFERIDA",
};

export const PROCESS_STATUS = {
    CREATED: 'CRIADA',
    ACCEPTED: 'DEFERIDA',
    REJECTED: 'INDEFERIDA',
    ARCHIVED: 'ARQUIVADA',
    UNDER_DILIGENCE: 'DILIGENCIA',
}

export const PROCESS_TRIAL_STATUS = {
    ALL: 'Todos',
    PENDING: 'Não Julgados',
    UNDER_JUDGEMENT: 'Em Julgamento',
    FINISHED: 'Julgados',
    ARCHIVED: 'Arquivados',
    UNDER_DILIGENCE: 'Diligência',
};

export const POOL_DECISION = {
    UNANIMOUS_ACCEPTANCE: 'Acata Unânime',
    ACCEPT_NOT_UNANIMOUSLY: 'Acata Não Unânime',
    DOES_NOT_COMPLY: 'Não Acata',
}

export const processesService = {
    list: async (data = {}) => {
        try {
            const searchParams = toSearchFilter(data);
            const response = await api.post(ENDPOINT_PROCESSES_LIST, searchParams);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.list";
        }
    },

    lookupUsers: async (data = {}) => {
        try {
            const response = await api.get(ENDPOINT_PROCESSES_USER_LIST, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.list";
        }
    },

    create: async (data) => {
        try {
            const response = await api.post(ENDPOINT_PROCESSES, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "process.messages.errors.create";
        }
    },

    find: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_PROCESSES_GET_DETAIL_UPDATE_DELETE}${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.find";
        }
    },

    /**
     * Processos vinculados à mesma infração (AIT). Resposta esperada: array ou { content | processos | data }.
     * Itens: pelo menos { id }; rótulo: numero ou nome.
     */
    listByInfractionId: async (idInfracao) => {
        try {
            const response = await api.get(`${ENDPOINT_PROCESSES_BY_INFRACTION}${idInfracao}`);
            const raw = response.data;
            const list = Array.isArray(raw) ? raw : raw?.content ?? raw?.processos ?? raw?.data ?? [];
            return Array.isArray(list) ? list : [];
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.list";
        }
    },

    update: async (id, data) => {
        try {
            const response = await api.put(`${ENDPOINT_PROCESSES_GET_DETAIL_UPDATE_DELETE}${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "process.messages.errors.update";
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`${ENDPOINT_PROCESSES_GET_DETAIL_UPDATE_DELETE}${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.delete";
        }
    },

    deleteAttachment: async (id) => {
        try {
            const response = await api.delete(`${ENDPOINT_PROCESSES_ATTACHMENT_DELETE}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.remove-attachment";
        }
    },

    listDocumentTypes: async () => {
        try {
            const response = await api.get(ENDPOINT_DOCUMENT_TYPES);
            return response?.data?._embedded?.content ?? [];
        } catch (error) {
            throw error.response?.data?.message;
        }
    },

    forward: async (id, data) => {
        try {
            const response = await api.post(`${ENDPOINT_PROCESSES_FORWARD}/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "process.messages.errors.forward";
        }
    },

    export: async () => {
        try {
            const response = await api.get(ENDPOINT_PROCESSES_EXPORT, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.export";
        }
    },

    attachmentDocument: async (id, data) => {
        try {
            const response = await api.post(
                `${ENDPOINT_PROCCESSES_ATTACH_DOCUMENT}/${id}`,
                data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.attach-document";
        }
    },

    archive: async (id, data) => {
        try {
            const response = await api.post(`${ENDPOINT_PROCESSES_ARCHIVE}/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.archive";
        }
    },

    judge: async (id, data) => {
        try {
            const response = await api.post(`${ENDPOINT_PROCESSES_JUDGE}/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.judge";
        }
    },

    reassign: async (id) => {
        try {
            const response = await api.post(`${ENDPOINT_PROCESSES_REASSIGN}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.reassign";
        }
    },

    reopen: async (id) => {
        try {
            const response = await api.put(`${ENDPOINT_PROCESSES_REOPEN}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.reopen";
        }
    },

    confirmReceipt: async (id, data) => {
        try {
            const response = await api.post(`${ENDPOINT_PROCESSES_CONFIRM_RECEIPT}/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "process.messages.errors.confirm-receipt";
        }
    },

    getPrintCaDetails: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_PROCESSES_PRINT_CA_DETAILS}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.print-ca";
        }
    },

    getProcessAttachment: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_PROCESSES_ATTACHMENT_VIEW}/${id}`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.view-attachment";
        }
    },

    reexamine: async (id, formData) => {
        try {
            const response = await api.post(`${ENDPOINT_PROCESSES_REEXAMINE}/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.process-reexamination.messages.errors.reexamination";
        }
    },

    sendMail: async (id, data) => {
        try {
            const response = await api.post(
                `${ENDPOINT_PROCESSES_SEND_MAIL}/${id}`,
                data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.send-mail";
        }
    },

    finalDecision: async (id, data) => {
        try {
            const response = await api.post(`${ENDPOINT_PROCESSES_FINAL_DECISION}/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "process.fill-final-decision.messages.errors.final-decision";
        }
    },

    listProcessTypes: async (params) => {
        try {
            const response = await api.get(ENDPOINT_PROCESS_TYPES, { params });
            return response?.data;
        } catch (error) {
            throw error.response?.data?.message;
        }
    },

    printNpsTrial: async (trialDate) => {
        try {
            const response = await api.post(ENDPOINT_PROCESS_PRINT_NP_TRIAL,
                { data_limite_julgamento: trialDate },
                { headers: { 'Content-Type': 'application/json' } }
            );
            return response?.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.print-nps-trial";
        }
    },

    listDepartments: async () => {
        try {
            const response = await api.get(ENDPOINT_PROCESSES_DEPARTMENT_LIST);
            return response?.data;
        } catch (error) {
            throw error.response?.data?.message || "process.messages.errors.list";
        }
    },
};
